import { useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../Core/RichText';
import InterestsTableComponent from '../../Providers/Core/Services/InterestsTable';

import { StyledContainer, Content, HtmlContent } from './styles';

const Paragraph = ({ data, className = '' }) => {
  if (!data) return null;
  const { id, component, paragraphHeading, paragraphCopy, paragraph } = data;

  const body = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => {
        return <>{children}</>;
      },
      [BLOCKS.EMBEDDED_ENTRY]: node => {
        const { data: nodeData } = node;
        if (nodeData.target.__typename === 'ContentfulCoreApi') {
          return <InterestsTableComponent />;
        }
        return null;
      },
    },
  };

  // replace credit limit params in text for legal page stuff
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const params = new URL(document.location).searchParams;
      const limitParams = params.get('limit') || '';
      document.querySelectorAll('td').forEach(td => {
        if (td.innerHTML.includes('{CREDIT-LIMIT}')) {
          td.innerHTML = td.innerHTML.replace('{CREDIT-LIMIT}', limitParams);
        }
      });
    }
  });

  return (
    <StyledContainer className={`${className} ${component}`} key={id}>
      {paragraphHeading && (
        <Content>
          {ReactHtmlParser(paragraphHeading.childMarkdownRemark.html)}
        </Content>
      )}
      {paragraph ? (
        <>
          {paragraph && (
            <Content>
              <RichText document={paragraph} options={body} />
            </Content>
          )}
        </>
      ) : (
        <>
          {paragraphCopy && (
            <HtmlContent>
              {ReactHtmlParser(paragraphCopy.childMarkdownRemark.html)}
            </HtmlContent>
          )}
        </>
      )}
    </StyledContainer>
  );
};

Paragraph.propTypes = {
  data: PropTypes.shape().isRequired,
  className: PropTypes.string,
};

export default Paragraph;
